import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { NotificationService } from "ng/src/app/notifications/notification.service";
import { SystemNotificationService } from "ng/src/app/notifications/system-notification.service";
import { PersistentDialogService } from "ng/src/app/shared/persistent-dialog/persistent-dialog.service";
import { Notification, SystemNotification } from 'ng/src/app/notifications/notification.model';
import { NotificationEntryComponent } from "ng/src/app/notifications/notification-entry/notification-entry.component";
import { PersistentDialogController } from "ng/src/app/shared/persistent-dialog/persistent-dialog.model";
import { Dialog } from "primeng/dialog";
import { SystemNotificationEntryComponent } from "ng/src/app/notifications/system-notification-entry/system-notification-entry.component";
import { OverlayPanel } from "primeng/overlaypanel";
import { ILocationService } from "angular";

type NotificationWithLog = Notification.Projections.WithLogName;

@Component({
	selector: 'notification-button',
	template: `
		<div (click)="showOverlay($event, notificationOverlay)" class="p-d-inline-flex p-jc-center p-ai-center clickable">
			<i #bellIcon style="color: white" class="fa fa-bell p-mr-1"></i>
            <p-badge *ngIf="bellCount" size="x-large" severity="danger" [value]="bellCount"></p-badge>
		</div>
		<p-overlayPanel #notificationOverlay appendTo="body" styleClass="notification-button-overlay" [style]="{ width: '450px' }">
			<ng-template pTemplate="content">
				<p-card>
					<ng-template pTemplate="header">
						<div class="p-d-flex p-ai-center p-jc-center">
							<button class="p-button-link" pButton label="Notifications" (click)="navigateToNotifications()" title="View notifications"></button>
						</div>
					</ng-template>
					
                    <dual-notification-container
                            (onSystemNotificationSelected)="onSystemNotificationSelected($event)"
                            (onNotificationSelected)="onNotificationSelected($event)">
                    </dual-notification-container>
					
				</p-card>
			</ng-template>
		</p-overlayPanel>
	`,
	styleUrls: ['./notification-button.component.scss']
})
export class NotificationButtonComponent {
	
	@ViewChild('bellIcon') bellIcon?: ElementRef;
	
	constructor(
		private notificationService: NotificationService,
		private systemNotificationService: SystemNotificationService,
		private dialogService: PersistentDialogService,
		@Inject('$location')
		private $location: ILocationService
	) {}
	
	get bellCount() {
		const combined = this.notificationService.unreadCount + this.systemNotificationService.getUnreadCount();
		return combined === 0 ? '' : combined > 10 ? '9+' : combined.toString();
	}
	
	onNotificationSelected(notification: NotificationWithLog) {
		const controller = new PersistentDialogController(NotificationEntryComponent)
			.setOnComponentCreated(c => {
				c.instance.notification = notification;
			})
			.setOnDialogCreated(this.customizeDialog);
		
		this.dialogService.next(controller);
	}
	
	onSystemNotificationSelected(notification: SystemNotification) {
		const controller = new PersistentDialogController(SystemNotificationEntryComponent)
			.setOnComponentCreated(c => {
				c.instance.notification = notification;
			})
			.setOnDialogCreated(this.customizeDialog);
		
		this.dialogService.next(controller);
	}
	
	showOverlay(event: Event, panel: OverlayPanel) {
		panel.show(event, this.bellIcon?.nativeElement ?? event.target);
	}
	
	navigateToNotifications() {
		this.$location.path('/notifications');
	}
	
	private customizeDialog(dialog: Dialog) {
		dialog.draggable = false;
		dialog.modal = true;
		dialog.resizable = false;
		dialog.dismissableMask = true;
		dialog.style = { width: '750px', height: '1000px' }
	}
}